<template>
  <!--进度组件--->
  <div class="process-container">
    <el-progress :percentage="percentage" color="#67c23a">
      <span v-if="scope.row.total || scope.row.total !== 0">{{
        scope.row.progress + "/" + scope.row.total
      }}</span>
      <span v-else>0 / 0</span>
    </el-progress>
  </div>
</template>
<script>
import {
  getCurrentInstance,
  defineComponent,
  ref,
  provide,
  reactive,
  onMounted,
  watch,
  toRefs,
  computed,
} from "vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  name: "process",
  components: {},
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const state = reactive({});
    onMounted(() => {});
    const percentage = computed(() => {
      if (props.scope.row.total && props.scope.row.total > 0) {
        return (props.scope.row.progress / props.scope.row.total) * 100;
      } else {
        return 0;
      }
    });
    return {
      ...toRefs(state),
      percentage,
    };
  },
});
</script>
<style scoped lang="less">
.process-container {
  width: 100%;
}
</style>
